export interface SessionClockParts {
  clock: string
  period: string
}

function parseTime24(value: string): { hours: number; minutes: string } | null {
  const match = value.trim().match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return null

  const hours = parseInt(match[1], 10)
  const minutes = match[2]
  if (Number.isNaN(hours) || hours < 0 || hours > 23) return null

  return { hours, minutes }
}

export function formatSessionClockParts(value: string, locale = 'en'): SessionClockParts {
  const parsed = parseTime24(value)
  if (!parsed) return { clock: value, period: '' }

  const { hours, minutes } = parsed
  const clock = `${hours % 12 || 12}:${minutes}`

  if (locale.startsWith('ar')) {
    return { clock, period: hours < 12 ? 'صباحا' : 'مساء' }
  }

  return { clock, period: hours < 12 ? 'AM' : 'PM' }
}

export function formatSessionClockTime(value: string, locale = 'en') {
  const { clock, period } = formatSessionClockParts(value, locale)
  if (!period) return clock
  return `${clock} ${period}`
}

export function formatSessionTimeRange(
  start?: string | null,
  end?: string | null,
  locale = 'en',
) {
  const from = start?.trim() ? formatSessionClockTime(start, locale) : ''
  const to = end?.trim() ? formatSessionClockTime(end, locale) : ''

  if (from && to) return `${from} – ${to}`
  return from || to || ''
}
